<template>
    <div>
        <el-form :inline="true" class="forTbFilter">
            <el-form-item label="ICCID号：">
                <el-input v-model.trim="searchForm.iccid" @keyup.enter.native="getSimInfoListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="操作ID：">
                <el-input v-model.trim="searchForm.id" @keyup.enter.native="getSimInfoListHandle" clearable></el-input>
            </el-form-item>
            <el-form-item label="时间：" class="dateRange">
                <el-date-picker v-model="searchForm.time" range-separator="至" type="daterange" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item class="btnArea">
                <el-button type="primary" @click="getSimInfoListHandle">搜索查询</el-button>
                <el-button type="primary" @click="exportSimInfoHandle">导 出</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="tbpg.tableData" border   >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="ICCID号" width="160">
                <template slot-scope="scope">
                    <a href="javascript:void(0)" @click="goToDetailPage(scope.row)">{{ scope.row.iccid }}</a>
                </template>
            </el-table-column>
            <el-table-column prop="intoNo" label="接入号"></el-table-column>
            <el-table-column prop="reason" label="备注"></el-table-column>
            <el-table-column prop="stateName" label="状态"></el-table-column>
            <el-table-column prop="recordId" label="操作ID"></el-table-column>
            <el-table-column prop="name" label="操作人"></el-table-column>
            <el-table-column prop="createTime" label="时间"></el-table-column>
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>

    </div>
</template>

<script>
import {getSimInfoByEndTime, exportSimNoEndInfo} from '@/api/sim.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            searchForm: {
                iccid: '',
                time: '',
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },
        }
    },
    methods: {
        
        getSimInfoListHandle($event){
            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);

            getSimInfoByEndTime(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        goToDetailPage(row){
            this.$store.commit('menu/setFromPage', 'cardMgt');
            this.$store.commit('menu/setFromPageIccid', row.iccid);
            document.getElementById('cardDetailsMenu').click();
        },
        exportSimInfoHandle(){//导出excel文件
            common.deleteSpaceKey(this.searchForm); 
            this.$confirm("您确定要导出列表吗？", "提示" ,{          
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(() => {
                exportSimNoEndInfo(this.searchForm).then(res =>{
                    if(res.data.code == 200){
                        this.$message.success('数据导出中,请稍候去任务中心下载');
                    }else{
                        this.$message.error(res.data.msg);
                    }
                }).catch(err=>console.error(err));
            }).catch(() => {
                
            });
        },


        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getSimInfoListHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val
            this.getSimInfoListHandle();
        },
    },
    created(){
        this.getSimInfoListHandle();
    }
}
</script>

<style lang="less" scoped>

</style>

